import { createSelector } from '@ngrx/store';

const selectList = (state: any) => state.list;

// Base selector to access countries state
const selectCountriesState = createSelector(
  selectList,
  (lists) => lists.countries
);

// Selector to get the list of countries
export const selectCountries = createSelector(
  selectCountriesState,
  (countriesState) => countriesState.countries
);

// Selector to check if the operation was successful
export const selectCountriesSuccess = createSelector(
  selectCountriesState,
  (countriesState) => countriesState
);

// Selector to get any errors from operations
export const selectCountriesFailure = createSelector(
  selectCountriesState,
  (countriesState) => countriesState.error
);
